import { GHGEmissionsReportSettings } from '@/hooks'

export type EmissionScopeKey =
    | 'scope1Direct'
    | 'scope2LocationBased'
    | 'scope2MarketBased'

export const getEmissionScopes = (
    settings: GHGEmissionsReportSettings,
    t: (key: string) => string
) => {
    const allScopes = [
        {
            id: 'scope1Direct',
            header: t('sustainability.table.scope1_direct'),
        },
        {
            id: 'scope2LocationBased',
            header: t('sustainability.table.scope2_location_based'),
        },
        {
            id: 'scope2MarketBased',
            header: t('sustainability.table.scope2_market_based'),
        },
    ]

    // Case: scope: scope1
    if (settings.scope === 'scope1') {
        return [allScopes[0]]
    }

    // Case: scope: scope2
    if (settings.scope === 'scope2') {
        if (settings.scope2type === 'all') {
            return [allScopes[1], allScopes[2]]
        }
        if (settings.scope2type === 'locationBased') {
            return [allScopes[1]]
        }
        if (settings.scope2type === 'marketBased') {
            return [allScopes[2]]
        }
    }

    // Case: scope: all
    if (settings.scope === 'all') {
        // If scope2type is 'all', show all scopes
        if (settings.scope2type === 'all') {
            return allScopes
        }
        // If locationBased, show scope1 and locationBased
        if (settings.scope2type === 'locationBased') {
            return [allScopes[0], allScopes[1]]
        }
        // If marketBased, show scope1 and marketBased
        if (settings.scope2type === 'marketBased') {
            return [allScopes[0], allScopes[2]]
        }
    }
    // fallback: show all
    return allScopes
}
